import React from "react";
import PropTypes from "prop-types";

export default function Icon(props) {
  const icon = require(`assets/${props.hasOwnProperty("path") ? props.path : "icons"}/${props.name}.svg`).default;

  // Keep the DOM clean by not putting name or description in it.
  const filteredProps = Object.keys(props)
    .filter((key) => (!["name", "description", "tooltip", "setTooltipText", "path"].includes(key)))
    .reduce((obj, key) => {
      obj[key] = props[key];
      return obj;
    }, {});

  return (
    <svg viewBox={icon.viewBox} {...filteredProps}>
      <title>
        { props.hasOwnProperty("description") ? props.description : `${props.name} icon` }
      </title>
      <use xlinkHref={`#${icon.id}`} />
    </svg>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
};
